// Test IDs for the coach onboarding + admin moderation surfaces.

export const APPLY = {
  page: "apply-page",
  form: "apply-form",
  name: "apply-name",
  headline: "apply-headline",
  bio: "apply-bio",
  email: "apply-email",
  city: "apply-city",
  rate: "apply-rate",
  years: "apply-years",
  specialties: "apply-specialties",
  languages: "apply-languages",
  avatarUrl: "apply-avatar-url",
  coverUrl: "apply-cover-url",
  sampleLink: "apply-sample-link",
  submit: "apply-submit",
  success: "apply-success",
  error: "apply-error",
};

export const ADMIN = {
  page: "admin-page",
  loginForm: "admin-login-form",
  tokenInput: "admin-token-input",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout",
  tabApps: "admin-tab-applications",
  tabReviews: "admin-tab-reviews",
  appsList: "admin-apps-list",
  appItem: (id) => `admin-app-${id}`,
  appApprove: (id) => `admin-app-approve-${id}`,
  appReject: (id) => `admin-app-reject-${id}`,
  reviewsList: "admin-reviews-list",
  reviewItem: (id) => `admin-review-${id}`,
  reviewHide: (id) => `admin-review-hide-${id}`,
  reviewRestore: (id) => `admin-review-restore-${id}`,
  reviewsFilter: (s) => `admin-reviews-filter-${s}`,
  emptyState: "admin-empty-state",
};
